import { render } from "./EditEmployeeProfile.vue?vue&type=template&id=2a98b62c&scoped=true"
import script from "./EditEmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EditEmployeeProfile.vue?vue&type=script&lang=js"

import "./EditEmployeeProfile.vue?vue&type=style&index=0&id=2a98b62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a98b62c"]])

export default __exports__